/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One sync pipeline a provider runs on a cadence.
 */
export type DeviceIntegrationProviderSchedule = {
  /**
   * Target minutes between successful runs. Declared in code by the provider, not configurable per org.
   */
  intervalMinutes: number;
  /**
   * Schedule identifier (e.g. jamf_inventory).
   */
  schedule: string;
};

/** @internal */
export const DeviceIntegrationProviderSchedule$inboundSchema: z.ZodMiniType<
  DeviceIntegrationProviderSchedule,
  unknown
> = z.pipe(
  z.object({
    interval_minutes: z.int(),
    schedule: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "interval_minutes": "intervalMinutes",
    });
  }),
);

export function deviceIntegrationProviderScheduleFromJSON(
  jsonString: string,
): SafeParseResult<DeviceIntegrationProviderSchedule, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeviceIntegrationProviderSchedule$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeviceIntegrationProviderSchedule' from JSON`,
  );
}
